import { render, staticRenderFns } from "./EditAder.vue?vue&type=template&id=1cfac980&scoped=true"
import script from "./EditAder.vue?vue&type=script&lang=js"
export * from "./EditAder.vue?vue&type=script&lang=js"
import style0 from "./EditAder.vue?vue&type=style&index=0&id=1cfac980&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfac980",
  null
  
)

export default component.exports